const homePage = () => import('@/views/home/home.vue')  //  游戏大厅
const setPage = () => import('@/views/set/set.vue')  //  设置中心
const errorPage = () => import('@/views/error/index.vue')  //  404页面
const loginPage = () => import('@/views/login/index.vue')  //  登录页面
const setPhonePage = () => import('@/views/setPhone/setPhone.vue')  //  绑定手机号码
const setPasswordPage = () => import('@/views/setPassword/setPassword.vue')  //  设置密码
const reportChangesPage = () => import('@/views/reportChanges/reportChanges.vue')  //  设置密码
const registerPage = () => import('@/views/register/register.vue')  //  注册
const findPasswordPage = () => import('@/views/findPassword/findPassword.vue')  //  忘记密码
const reportPage = () => import('@/views/report/report.vue')  //  报表中心
const transactionPage = () => import('@/views/transaction/transaction.vue')  //  交易
const publishNewsPage = () => import('@/views/publishNews/publishNews.vue')   // 发布消息
const historyBuyPage = () => import('@/views/historyBuy/historyBuy.vue')   // 历史记录
const exchangePage = () => import('@/views/exchange/exchange.vue')   // 兑换
const exchangeRecordPage = () => import('@/views/exchangeRecord/exchangeRecord.vue')   // 兑换记录
const addBankPage = () => import('@/views/addBank/addBank.vue')   // 添加银行卡
const flowerFallGamePage = ()  => import('@/views/flowerFallGame/flowerFallGame.vue')   // 花落游戏
const rechargePage = ()  => import('@/views/recharge/recharge.vue')   // 充值
const signingBonusPage = ()  => import('@/views/signingBonus/signingBonus.vue')   // 契约金
const insuranceBoxPage = () => import('@/views/insuranceBox/insuranceBox.vue')   // 保险箱
const sharePage = () => import('@/views/share/share.vue')   // 分享
const bulletinListPage = () => import('@/views/bulletinList/bulletinList.vue')   // 公告列表
const noticeDataPage = () => import('@/views/noticeData/noticeData.vue')   // 公告详情
const addMemberPage = () => import('@/views/addMember/addMember.vue')   // 添加会员
const registerEvePage = () => import('@/views/registerEve/registerEve.vue')   // 注册页
const luckDrawPage = () => import('@/views/luckDraw/luckDraw.vue')   // 抽奖
const luckDrawHistoryPage = () => import('@/views/luckDrawHistory/luckDrawHistory.vue')   // 抽奖历史记录
const luxuryCarPage = () => import('@/views/luxuryCar/luxuryCar.vue')   // 豪车漂移
const towerDefensePage = () => import('@/views/towerDefense/towerDefense.vue')   // 对公塔防
const addTowerPage = () => import('@/views/addTower/addTower.vue')   // 对公塔防开房
const BullfightPage = () => import('@/views/Bullfight/Bullfight.vue')   // 牛牛
const applyTextPage = () => import('@/views/applyText/applyText.vue')
const routes = [
  {
    path: '/home',
    component: homePage,
    name: '大厅',
    meta: {title: '大厅'}
  },
  {
    path: '/set',
    component: setPage,
    name: '设置',
    meta: {title: '设置'}
  },
  {
    path: '/report',
    component: reportPage,
    name: '报表中心',
    meta: {title: '报表中心'}
  },
  {
    path: '/reportChanges',
    component: reportChangesPage,
    name: '帐变',
    meta: {title: '帐变'}
  },
  {
    path: '/register',
    component: registerPage,
    name: '注册',
    meta: {title: '注册'}
  },
  {
    path: '/findPassword',
    component: findPasswordPage,
    name: '忘记密码',
    meta: {title: '忘记密码'}
  },
  {
    path: '/setPhone',
    component: setPhonePage,
    name: '绑定手机号码',
    meta: {title: '绑定手机号码'}
  },
  {
    path: '/setPassword',
    component: setPasswordPage,
    name: '设置密码',
    meta: {title: '设置密码'}
  },
  {
    path: '/',
    component: loginPage,
    name: '登陆',
    meta: {title: '手机号验证'}
  },
  {
    path: '/transaction',
    component: transactionPage,
    name: '交易',
    meta: {title: '交易'}
  },
  {
    path: '/publishNews',
    component: publishNewsPage,
    name: '发布消息',
    meta: {title: '发布消息'}
  },
  {
    path: '/historyBuy',
    component: historyBuyPage,
    name: '历史记录',
    meta: {title: '历史记录'}
  },
  {
    path: '/exchange',
    component: exchangePage,
    name: '兑换',
    meta: {title: '兑换'}
  },
  {
    path: '/exchangeRecord',
    component: exchangeRecordPage,
    name: '兑换记录',
    meta: {title: '兑换记录'}
  },
  {
    path: '/addBank',
    component: addBankPage,
    name: '添加银行卡',
    meta: {title: '添加银行卡'}
  },
  {
    path: '/flowerFallGame',
    component: flowerFallGamePage,
    name: '花落游戏',
    meta: {title: '花落游戏'}
  },
  {
    path: '/recharge',
    component: rechargePage,
    name: '充值',
    meta: {title: '充值'}
  },
  {
    path: '/signingBonus',
    component: signingBonusPage,
    name: '契约金',
    meta: {title: '契约金'}
  },
  {
    path: '/insuranceBox',
    component: insuranceBoxPage,
    name: '保险箱',
    meta: {title: '保险箱'}
  },
  {
    path: '/sharePage',
    component: sharePage,
    name: '分享',
    meta: {title: '分享'}
  },
  {
    path: '/bulletinList',
    component: bulletinListPage,
    name: '公告',
    meta: {title: '公告'}
  },
  {
    path: '/noticeData',
    component: noticeDataPage,
    name: '公告详情',
    meta: {title: '公告详情'}
  },
  {
    path: '/addMember',
    component: addMemberPage,
    name: '公告详情',
    meta: {title: '公告详情'}
  },
  {
    path: '/registerEve',
    component: registerEvePage,
    name: '欢迎注册',
    meta: {title: '欢迎注册'}
  },
  {
    path: '/404',
    component: errorPage,
    name: '页面不存在',
    meta: {}
  },
  {
    path: '/luckDraw',
    component: luckDrawPage,
    name: '抽奖',
    meta: {}
  },
  {
    path: '/luckDrawHistory',
    component: luckDrawHistoryPage,
    name: '抽奖记录',
    meta: {}
  },
  {
    path: '/luxuryCar',
    component: luxuryCarPage,
    name: '豪车漂移',
    meta: {}
  },
  {
    path: '/towerDefense',
    component: towerDefensePage,
    name: '对公塔防',
    meta: {}
  },
  {
    path: '/addTower',
    component: addTowerPage,
    name: '对公塔防开房',
    meta: {}
  },
  {
    path: '/Bullfight',
    component: BullfightPage,
    name: '牛牛',
    meta: {}
  },
  {
    path: '/applyText',
    component: applyTextPage,
    name: '',
    meta: {}
  },
  {
    path: '*',
    redirect: '/404'
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js